/**
 * Product Form Components
 *
 */
class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.cartElement = document.querySelector('cart-form');    
  }

  connectedCallback() {
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    if(this.querySelector('[data-qty-container]')){
      this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
    }
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();
    const addItems = [];
    const submitButton = this.querySelector('[type="submit"]');
    const qtyInput = this.querySelector('[data-qty-input]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    addItems.push(JSON.parse(Utility.serializeForm(this.form)));
    const body = JSON.stringify({
      items: addItems,
      sections: `${((window.globalVariables.template == 'cart') ? 'template-cart' : 'component-cart-drawer')},header` 
    });
    
    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
    .then((response) => response.json())
    .then((res) => {
      let dataJSON = ((typeof res == 'object') ? res : JSON.parse(res));
      if(dataJSON.errors){
        window.notificationEle.updateNotification('Add to Cart', dataJSON.errors, {
          type: 'error',
          timeout: 5000
        });
        return false;
      }

      if(document.querySelector('#PopupModal-quickshop')){
        document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'))
      }
      if(qtyInput) qtyInput.value = 1;
      if(this.cartElement){
        this.cartElement._updateCart(dataJSON.sections, 'open_drawer');
        // this.cartElement.getCartData('open_drawer');
      }else{
        window.location.href = window.routes.cart_fetch_url;
      }      
    })
    .catch((e) => {
      window.notificationEle.updateNotification('Error', e, {
        type: 'error',
        timeout: 5000
      });
      console.error(e);
    })
    .finally(() => {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('disabled');
    });
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || 'increase';
    let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;
    let decreaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="decrease"]');

    if(action == 'decrease' && currentQty <= 1){
      if(decreaseQtyBtn) decreaseQtyBtn.classList.add('disabled');
      return false;
    }else if(action == 'decrease'){
      finalQty = currentQty - 1;
      finalQty == 1 ? decreaseQtyBtn.classList.add('disabled') : decreaseQtyBtn.classList.remove('disabled');
    }else{
      if(decreaseQtyBtn) decreaseQtyBtn.classList.remove('disabled');
      finalQty = currentQty + 1;
    }

    $qtyInput.value = finalQty;
  }
}
customElements.define('product-form', ProductForm);

/**
 * Dropdown selection for options
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form') || this.closest('.form-element');
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variantPicker = this.dataset.type;
  }

  connectedCallback() {
    // Element Connected callback
    // if(this.formType == 'product-page') this.onVariantChange('load');
    this.onVariantChange('load');
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  /**
   * Trigger this function variant is changed
   * @param {event} _event 
   */
  onVariantChange(_event) {
    this.setCurrentVariant();
    this.updateVariantStatuses();
    
    if(this.formType == 'product-page') window.globalVariables.product.currentVariant = this.currentVariant;
    document.dispatchEvent(new Event('variant:changed'));
    
    if (!this.currentVariant) {
      this.toggleAddButton('disable');
      this.updateOptionLabel(this.form); 
    } else {
      if(this.formType == 'grid'){
 
        const productGrid = this.closest('[data-product-grid]');
        this.renderProductInfo(this.currentVariant, productGrid);
        this._updateLinks(productGrid); 
        if(this.currentVariant.inventory_quantity == 0){
          productGrid.querySelector('.badge-sold').classList.remove('d-none');
        }else{
          productGrid.querySelector('.badge-sold').classList.add('d-none');
        }
      }else{
        const productPage = this.closest('[data-product-container]');
        this.renderProductInfo(this.currentVariant, productPage);
      }
      this.updateURLandID(this.currentVariant);
      this.toggleAddButton('enable');
    }
  }

  /**
   * Change product variant url link in product card when variant is being updated
   * @param {element} productGrid 
   */
  _updateLinks(productGrid){
    // console.log('_updateLinks',productGrid);
    if(!this.currentVariant || !productGrid) return;
    const variantURL = `?variant=${this.currentVariant.id}`;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });

    productGrid.querySelectorAll('[data-return-pdp-url]').forEach(loginBtn => loginBtn.addEventListener('click', this.storePDPURL.bind(this)));
    
  }

  storePDPURL(event){
    // event.preventDefault();
    let getCurrentURL = window.location.href;
    // console.log('getCurrentURL',getCurrentURL);
    let collectionName = event.currentTarget.getAttribute('data-return-pdp-url');
    Utility.setCookie('getStoredPDPURL', getCurrentURL, 1);
    Utility.setCookie('getStoredPDPColl', collectionName, 1);
  }

  /**
   * Fetch selected options from dropdown
   */
  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('.variant_selector').forEach((selector)=>{
      options.push(selector.value);
    });
    return options;
  }

  /**
   * Fetch selected options from radio
   */
  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
    return fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked).value;
    });
  }

  /**
   * change value of currentVariant when variant being changed 
   */
  setCurrentVariant() {
    
    this.currentVariant = false;
    let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();

    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      if(!mappedValues.includes(false)){
        this.currentVariant = variant;
        return;
      }
    });
  }

  /**
   * Update selected option name label
   */
  updateOptionLabel(form){
    let options = form.querySelectorAll('[data-optionindex]');
    options.forEach(option => {
      let labelID = 'option'+option.dataset.optionindex;
      const label = option.querySelector('.selected-option');
      if(!label || !labelID) return;
      label.innerHTML = this.currentVariant[labelID];
    });
  }

  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant 
   */
  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    if(this.formType == 'product-page') window.history.replaceState({ }, '', `${this.dataset.url}?variant=${currentVariant.id}`);

    const input = this.form.querySelector('input[name="id"]');
    input.value = currentVariant.id;
  }

  /**
   * Render Price details based on current variant
   */
  priceUpdate(currentVariant, container){
    
    let priceElement = container.querySelector('[data-currentPrice]');
    let comparePriceElement = container.querySelector('[data-comparePrice]');
    let comparePriceParent = container.querySelector('.data-price-parent');
    let savePriceElement = container.querySelector('[data-save-price]');
    let discountBadge = container.querySelector('[data-discount-badge]');

    if(discountBadge){
      discountBadge.classList.add('d-none');
    }

    if(priceElement) priceElement.innerHTML = Utility.formatMoney(currentVariant.price, window.globalVariables.money_format);
    if(comparePriceElement) {
      if(comparePriceParent) comparePriceParent.classList.add('card-product-member-save-price');
      if((currentVariant.option1 != null && currentVariant.option1.toLowerCase() == 'non-member') || (currentVariant.option2 != null && currentVariant.option2.toLowerCase() == 'non-member') || (currentVariant.option3 != null && currentVariant.option3.toLowerCase() == 'non-member')){
        let memberVariant = this.getMemberVariant(currentVariant);
        
        // console.log('memberVariant',memberVariant.price, currentVariant.price);
        if(memberVariant.price < currentVariant.price){
          comparePriceElement.innerHTML = `(Member Price ${Utility.formatMoney(memberVariant.price, window.globalVariables.money_format)})`;
          if(savePriceElement){
            savePriceElement.closest('.data-price-parent').classList.remove('d-none');
          }
          comparePriceElement.classList.remove('d-none');
          let priceDifference = currentVariant.price - memberVariant.price;
          // console.log('priceDifference',priceDifference);
          if(savePriceElement){
            savePriceElement.innerHTML = `Become a member and save ${Utility.formatMoney(priceDifference, window.globalVariables.money_format)}`;
          }
        }else if(currentVariant.price < currentVariant.compare_at_price){
          if(discountBadge){
            discountBadge.classList.remove('d-none');
          }
          comparePriceElement.classList.remove('d-none');
          if(comparePriceParent) comparePriceParent.classList.remove('card-product-member-save-price');
          comparePriceElement.innerHTML = `<s>${Utility.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format)}</s>`;
          if(savePriceElement){
            savePriceElement.closest('.data-price-parent').classList.add('d-none');
          }
        }else{
          if(discountBadge){
            discountBadge.classList.add('d-none');
          }
          comparePriceElement.classList.add('d-none');
        }
      }else if((currentVariant.option1 != null && currentVariant.option1.toLowerCase() == 'member') || (currentVariant.option2 != null && currentVariant.option2.toLowerCase() == 'member') || (currentVariant.option3 != null && currentVariant.option3.toLowerCase() == 'member')){
        // console.log('11111');
        let nonMemberVariant = this.getNonMemberVariant(currentVariant);
        // console.log('nonMemberVariant',nonMemberVariant);
        if(savePriceElement == null){
          savePriceElement = comparePriceElement;
        }
        if(savePriceElement && currentVariant.price < currentVariant.compare_at_price){
          savePriceElement.closest('.data-price-parent').classList.remove('d-none');
          let priceDifference = currentVariant.compare_at_price- currentVariant.price;
          if(savePriceElement.hasAttribute('data-coll-grid')){
            savePriceElement.innerHTML = `(You save ${Utility.formatMoney(priceDifference, window.globalVariables.money_format)}!)`;
          }else{
            savePriceElement.innerHTML = `You save ${Utility.formatMoney(priceDifference, window.globalVariables.money_format)}!`;
            comparePriceElement.innerHTML = `<s>${Utility.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format)}</s>`;
            comparePriceElement.classList.remove('d-none');
          }
       
        }else if(savePriceElement && currentVariant.price > nonMemberVariant.price){
          savePriceElement.closest('.data-price-parent').classList.add('d-none');
          comparePriceElement.classList.add('d-none');
        }
      }else{
        if(savePriceElement && currentVariant.price < currentVariant.compare_at_price){
          // savePriceElement.closest('.data-price-parent').classList.remove('d-none');
          // let priceDifference = currentVariant.compare_at_price - currentVariant.price;
          // savePriceElement.innerHTML = `You save ${Utility.formatMoney(priceDifference, window.globalVariables.money_format)}!`;
        }else if(savePriceElement && currentVariant.price > currentVariant.compare_at_price){
          savePriceElement.closest('.data-price-parent').classList.add('d-none');
        }
        
      }
      
      
      // else{
      //   console.log('3');
      //   comparePriceElement.innerHTML = Utility.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
      // }
      
      
      // if(currentVariant.compare_at_price == null || currentVariant.compare_at_price <= 0 || currentVariant.compare_at_price < currentVariant.price){
      //   comparePriceElement.classList.add('d-none');
      // }else if(currentVariant.price < currentVariant.compare_at_price){
      //   comparePriceElement.classList.remove('d-none');
      // }
      
    }
  }

  getMemberVariant(currentVariant){
    let memberVariant = null;
    let variantsArray = this._getVariantData();
    let lowercaseOpt = currentVariant.options.map(v => v.toLowerCase());
    let optionIndex = lowercaseOpt.indexOf("non-member") + 1;
  
    variantsArray.forEach(function(value, index) {
      if(optionIndex == 1){
        if(currentVariant.option2 == value.option2 && currentVariant.option3 == value.option3 && value.option1.toLowerCase() == 'member'){
          memberVariant = value;
        }
      }else if(optionIndex == 2){
        if(currentVariant.option1 == value.option1 && currentVariant.option3 == value.option3 && value.option2.toLowerCase() == 'member'){
          memberVariant = value;
        }
      }else if(optionIndex == 3){
        if(currentVariant.option1 == value.option1 && currentVariant.option2 == value.option2 && value.option3.toLowerCase() == 'member'){
          memberVariant = value;
        }
      }
    });
    if(memberVariant != null){
      return memberVariant;
    }
  }

  getNonMemberVariant(currentVariant){
    let memberVariant = null;
    let variantsArray = this._getVariantData();
    let lowercaseOpt = currentVariant.options.map(v => v.toLowerCase());
    let optionIndex = lowercaseOpt.indexOf("member") + 1;
  
    variantsArray.forEach(function(value, index) {
      if(optionIndex == 1){
        if(currentVariant.option2 == value.option2 && currentVariant.option3 == value.option3 && value.option1.toLowerCase() == 'non-member'){
          memberVariant = value;
        }
      }else if(optionIndex == 2){
        if(currentVariant.option1 == value.option1 && currentVariant.option3 == value.option3 && value.option2.toLowerCase() == 'non-member'){
          memberVariant = value;
        }
      }else if(optionIndex == 3){
        if(currentVariant.option1 == value.option1 && currentVariant.option2 == value.option2 && value.option3.toLowerCase() == 'non-member'){
          memberVariant = value;
        }
      }
    });
    if(memberVariant != null){
      return memberVariant;
    }
  }

  // updateVariantStatuses() {
  //   const inputWrappers = [...this.querySelectorAll('.product-form__input')];
  //   if(inputWrappers.length > 1){
  //     var selectedOptionOneVariants = this.variantData.filter(
  //       (variant) => this.querySelector(':checked').value === variant.option1
  //     );
  //   }else{
  //     var selectedOptionOneVariants = this.variantData;
  //   }
   
  //   inputWrappers.forEach((option, index) => {
  //     console.log('heyyyyy',inputWrappers[index]);
  //     if(inputWrappers.length > 1){
  //       if (index == 0) return;
  //     }

  //     const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
  //     if(inputWrappers.length > 1){
  //       const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
  //       const availableOptionInputsValue = selectedOptionOneVariants
  //         .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
  //         .map((variantOption) => variantOption[`option${index + 1}`]);
  //       this.setInputAvailability(optionInputs, availableOptionInputsValue);
  //     }else{
  //       const availableOptionInputsValue = selectedOptionOneVariants
  //         .filter((variant) => variant.available)
  //         .map((variantOption) => variantOption[`option${index + 1}`]);
  //       this.setInputAvailability(optionInputs, availableOptionInputsValue);
  //     }
  //   });
  // }

  updateVariantStatuses() {
    // Determine target product type based on customer status (matching Liquid logic)
    // In Liquid: if customer and customer.orders_count > 0, then member, else non-member
    // Check if the form has a data attribute set by Liquid first, otherwise check JavaScript
    const form = this.closest('form');
    let targetProductType = form && form.getAttribute('data-target-product-type') ? form.getAttribute('data-target-product-type') : 'non-member';
    
    if (targetProductType === 'non-member' && window.RcustomerDetails && window.RcustomerDetails.id) {
      // If customer is logged in, check if they have orders (which makes them a member)
      // Note: allOrders might not be available on product pages, so we default to checking customer.id existence
      // The form's data-target-product-type should be the source of truth since it's set by Liquid
      if (window.allOrders && window.allOrders.length > 0) {
        targetProductType = 'member';
      }
    }
    
    // Filter variants to only include those matching the target product type (member/non-member)
    // Include both available and unavailable variants - we'll check availability separately
    const targetProductTypeVariants = this.variantData.filter((variant) => {
      const option1 = (variant.option1 || '').toLowerCase();
      const option2 = (variant.option2 || '').toLowerCase();
      const option3 = (variant.option3 || '').toLowerCase();
      
      const isTargetType = (targetProductType === 'member' && (option1 === 'member' || option2 === 'member' || option3 === 'member')) ||
                          (targetProductType === 'non-member' && (option1 === 'non-member' || option2 === 'non-member' || option3 === 'non-member'));
      
      return isTargetType;
    });
    
    // Check if variant is actually available (considering inventory policy)
    const checkVariantAvailability = (variant) => {
      let isAvailable = variant.available;
      if (variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny' && (variant.inventory_quantity || 0) <= 0) {
        isAvailable = false;
      }
      return isAvailable;
    };
    
    const inputWrappers = [...this.querySelectorAll('.product-form__input:not(.d-none)')];
    inputWrappers.forEach((option, index) => {
      const optionIndex = parseInt(option.getAttribute('data-optionindex')) || (index + 1);
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      
      if (index === 0) {
        // First visible option - get all option values from target product type variants
        const allOptionValues = targetProductTypeVariants
          .map((variantOption) => variantOption[`option${optionIndex}`])
          .filter((value, idx, self) => value && self.indexOf(value) === idx); // Get unique values
        
        // Get available option values
        const availableOptionValues = targetProductTypeVariants
          .filter(v => checkVariantAvailability(v))
          .map((variantOption) => variantOption[`option${optionIndex}`])
          .filter((value, idx, self) => value && self.indexOf(value) === idx); // Get unique values
        
        // Show all values, but enable only available ones
        this.setInputAvailabilityWithAllValues(optionInputs, allOptionValues, availableOptionValues);
      } else {
        // Subsequent options - filter based on previous selections
        const previousSelections = {};
        for (let i = 0; i < index; i++) {
          const prevOption = inputWrappers[i];
          const prevOptionIndex = parseInt(prevOption.getAttribute('data-optionindex')) || (i + 1);
          const prevSelected = prevOption.querySelector(':checked');
          if (prevSelected) {
            previousSelections[`option${prevOptionIndex}`] = prevSelected.value;
          }
        }
        
        // Also include the hidden product type selection
        const allInputWrappers = [...this.querySelectorAll('.product-form__input')];
        const productTypeWrapper = allInputWrappers.find(wrapper => {
          const legend = wrapper.querySelector('legend');
          if (legend) {
            const optionName = legend.textContent.toLowerCase();
            return optionName.includes('product type') || optionName.includes('member');
          }
          return false;
        });
        if (productTypeWrapper) {
          const productTypeSelected = productTypeWrapper.querySelector(':checked');
          if (productTypeSelected) {
            const productTypeIndex = parseInt(productTypeWrapper.getAttribute('data-optionindex')) || 1;
            previousSelections[`option${productTypeIndex}`] = productTypeSelected.value;
          }
        }
        
        // Filter variants based on all previous selections (including hidden product type)
        let filteredVariants = targetProductTypeVariants;
        if (Object.keys(previousSelections).length > 0) {
          filteredVariants = targetProductTypeVariants.filter((variant) => {
            return Object.keys(previousSelections).every(key => {
              const optionNum = parseInt(key.replace('option', ''));
              return variant[`option${optionNum}`] === previousSelections[key];
            });
          });
        }
        
        // Get all option values for this option
        const allOptionValues = filteredVariants
          .map((variantOption) => variantOption[`option${optionIndex}`])
          .filter((value, idx, self) => value && self.indexOf(value) === idx); // Get unique values
        
        // Get available option values
        const availableOptionValues = filteredVariants
          .filter(v => checkVariantAvailability(v))
          .map((variantOption) => variantOption[`option${optionIndex}`])
          .filter((value, idx, self) => value && self.indexOf(value) === idx); // Get unique values
        
        // Show all values, but enable only available ones
        this.setInputAvailabilityWithAllValues(optionInputs, allOptionValues, availableOptionValues);
      }

      if(inputWrappers[index].querySelector(':checked') && inputWrappers[index].querySelector(':checked').hasAttribute('disabled')){
        let radioButtons = inputWrappers[index].querySelectorAll('input[type="radio"]')
        for (var i = 0; i < radioButtons.length; i++) {
          if (!radioButtons[i].hasAttribute('disabled')) {
              radioButtons[i].checked = true;
              break;
          }
      }
      }
      
    });
    this.setCurrentVariant();
  }
  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);
      if (element.tagName === 'INPUT') {
        element.toggleAttribute('disabled', !availableElement)
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }
  
  setInputAvailabilityWithAllValues(elementList, allValuesList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      // Only process elements whose values are in the allValuesList (for target product type)
      if (allValuesList.includes(value)) {
        const isAvailable = availableValuesList.includes(value);
        if (element.tagName === 'INPUT') {
          element.toggleAttribute('disabled', !isAvailable);
          // Make sure the input is visible (not hidden) - options are already rendered by Liquid
          if (element.closest('li')) {
            element.closest('li').style.display = '';
          }
        } else if (element.tagName === 'OPTION') {
          element.disabled = !isAvailable;
          element.innerText = isAvailable
            ? value
            : window.variantStrings.unavailable_with_option.replace('[value]', value);
        }
      } else {
        // Hide values that don't exist for target product type (these shouldn't be rendered by Liquid anyway)
        if (element.tagName === 'INPUT' && element.closest('li')) {
          element.closest('li').style.display = 'none';
        } else if (element.tagName === 'OPTION') {
          element.style.display = 'none';
        }
      }
    });
  }
  
  
  // setInputAvailability(elementList, availableValuesList) {
  //   elementList.forEach((element) => {
  //     const value = element.getAttribute('value');
  //     const availableElement = availableValuesList.includes(value);

  //     if (element.tagName === 'INPUT') {
  //       element.toggleAttribute('disabled', !availableElement)
  //     } else if (element.tagName === 'OPTION') {
  //       element.innerText = availableElement
  //         ? value
  //         : window.variantStrings.unavailable_with_option.replace('[value]', value);
  //     }
  //   });
  // }

  /**
   * Render Product data based on current variant
   * @param {object} currentVariant 
   * @param {element} container 
   */
  renderProductInfo(currentVariant, container) {
    if(!currentVariant || !container) return;
   
    this.priceUpdate(currentVariant, container);
    this.updateOptionLabel(this.form); 

    const featured_image = currentVariant.featured_image || null;
    if(featured_image != null){
      if(this.formType == 'grid'){
        const featuredImage = container.querySelector('[data-feauredImage]');
        featuredImage.src = currentVariant.featured_image.src;
        featuredImage.srcset = currentVariant.featured_image.src;
      }else{
        let imageSlide = document.querySelector(`.product--media[data-mediaID="${currentVariant.featured_media.id}"]`);
        if(this.formType == 'quickshop'){
          imageSlide = document.querySelector(`.quickshop-slider .product--media[data-mediaID="${currentVariant.featured_media.id}"]`);
        }
        
        if(!imageSlide) return;
  
        let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
        if(this.formType == 'quickshop' && quickShopSlider){
          quickShopSlider.slideTo(slideIndex, 0, false);
        }else if(productSlider){
          productSlider.slideTo(slideIndex, 0, false);
        }
      }
    }
  }

  /**
   * Toggle the button based on product availability ( add to cart / soldOut )
   * @param {*} status enable / disable
   */
  toggleAddButton(status) {
    if (!this.addBtn) return;

    if (status == 'disable') {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.unavailable;
    } else if(this.currentVariant && !this.currentVariant.available) {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.soldOut;
    } else {
      this.addBtn.removeAttribute('disabled');
      if(this.form.classList.contains('cart-upsell-form')){
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.upsellAddText;
      }else{
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;
      }
    }
  }

  /**
   * Store the all the variants json
   */
  _getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);

/**
 * Radio Button swatch
 */
class VariantRadios extends VariantSelects {
  constructor() {
    super();

    this.form = this.closest('form') || this.querySelector('.form-element');
    this.formType = this.form.dataset.format;

    const colorSwatchContainer = this.querySelector('.color-swatch');
    if(colorSwatchContainer){
      const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
        let swatchStyle;
        if(swatch.hasAttribute('data-hex-code') == true){
          swatchStyle = swatch.getAttribute('data-hex-code');
          swatch.querySelector('.swatch-label').setAttribute('style', `background-color: ${swatchStyle}`);
        }else{
          swatchStyle = Utility.getSwatchStyle(colorHandle);
          swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
        }
        
        
      });
    }
  }
}
customElements.define('variant-radios', VariantRadios);